import { AccountLayout } from '../../layouts';
import { Generate2FaQrForm } from '../../components/Generate2FaQrForm';

export const Generate2FaQrPage = () => {
  return (
    <AccountLayout
      contents={<Generate2FaQrForm />}
      contentColumns={5}
    />
  );
};
